module.exports = __webpack_public_path__ + "img/tivd.9674a3ff.gif";